"use client";

import { motion } from "framer-motion";
import { Button } from "@/components/ui/button/Button";
import { HeroCard } from "./HeroCard";

export function Hero() {
  return (
    <section className="w-full max-w-7xl mx-auto px-5 md:px-8 py-24 sm:py-32 flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-20">
      {/* ── Left: hero title + hero Description + hero CTAs ──────────────────────── */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="flex-1 gap-3.5 flex flex-col items-center lg:items-start max-w-145 text-center lg:text-left"
      >
        <h1 className="text-[48px] sm:text-[58px] lg:text-7xl font-medium text-text-primary leading-[1.08] tracking-tight mb-5">
          Know what&apos;s
          <br />
          safe to spend.
          <br />
          Today.
        </h1>

        <p className="md:text-xl text-text-secondary leading-[1.65] max-w-125 mb-8">
          Repayas connects to your business bank account, separates VAT from
          operating cash, and gives you one clear number you can trust before
          you spend.
        </p>

        {/* CTAs */}
        <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mb-5">
          <Button
            variant="primary"
            size="lg"
            href="/signup"
            id="hero-cta-start-trial"
            className="h-12 px-7 text-[15px] font-semibold rounded-[14px]"
          >
            Start free trial
          </Button>
          <Button
            variant="secondary"
            size="lg"
            href="#how-it-works"
            id="hero-cta-how-it-works"
            className="h-12 px-7 text-[15px] font-medium rounded-[14px] border border-[#E8E6E3] bg-white"
          >
            See how it works
          </Button>
        </div>

        {/* Trust line */}
        <p className="text-[13px] text-gray-400 font-normal mt-2 tracking-normal">
          Open Banking via TrueLayer · UK businesses only · No card required
        </p>
      </motion.div>

      {/* ── Right: hero card ─────────────────────────────────────
      ────────────────────────────────────────────────────────────────── */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut", delay: 0.2 }}
        className="w-full max-w-110 shrink-0"
      >
        <HeroCard />
      </motion.div>
    </section>
  );
}
